import React from 'react';
import SearchResultsDF from '../components/SimulatorsComponents/DefualtSimulators/SearchResultsDF';

const Sim_B02_SendMoneySearchResults = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SearchResultsDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_B02_SendMoneySearchResults;
